import * as React from "react";
import "../theme.css";
import { Link } from "react-router-dom";
import { CoreText, CoreTextType } from "../text/text";

interface CoreButtonProps
  extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, "style"> {
  block?: boolean;
  filled?: boolean;
  text?: string;
  textStyle?: React.CSSProperties;
  style?: React.CSSProperties;
  to?: string;
}
export function CoreButton({
  block,
  filled,
  text,
  textStyle,
  style,
  to,
  children,
  type = "button",
  disabled,
  ...props
}: CoreButtonProps) {
  const buttonStyle: React.CSSProperties = {
    minHeight: 44,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 6,
    backgroundColor: filled ? "var(--ui-primary)" : "var(--ui-surface)",
    padding: "10px 20px",
    borderRadius: "var(--ui-control-radius)",
    border: block
      ? "1px solid var(--ui-outline)"
      : filled
        ? "1px solid transparent"
        : "1px solid var(--ui-outline)",
    fontFamily: "var(--ui-font)",
    fontSize: 14,
    fontWeight: 400,
    textDecoration: "none",
    lineHeight: "20px",
    color: filled ? "var(--ui-primary-text)" : "var(--ui-text)",
    cursor: disabled ? "default" : "pointer",
    opacity: disabled ? 0.5 : undefined,
    ...style,
  };
  const className = [
    "core-button",
    filled ? "core-button-filled" : "",
    props.className,
  ]
    .filter(Boolean)
    .join(" ");
  const content =
    text !== undefined ? (
      <CoreText
        as="span"
        text={text}
        type={CoreTextType.medium}
        style={textStyle}
        color={buttonStyle.color}
      />
    ) : (
      children
    );
  if (to)
    return (
      <Link
        to={to}
        className={className}
        aria-label={props["aria-label"]}
        style={buttonStyle}
      >
        {content}
      </Link>
    );
  return (
    <button
      {...props}
      className={className}
      type={type}
      disabled={disabled}
      style={buttonStyle}
    >
      {content}
    </button>
  );
}
